import { hasMany, attr } from '@ember-data/model';
import { readOnly } from '@ember/object/computed';
import ShModel from './sh-model';

/**
 * Given all loaded regions and a location, return the region for the location
 *
 * @param {Array<Region>} regions   Typically this should be ALL the SH Region models
 * @param {Array<Location>} location
 * @return {Country}
 */
const getRegionModelForLocation = (regions, location) => {
  const regionMap = regions.reduce((map, region) => {
    const regionId = Number.parseInt(region.id);
    map.set(regionId, region);
    return map;
  }, new Map());

  const regionById = regionMap.get(location.regionId);

  return regionById ?? null;
};

export const REGION = {
  getRegionModelForLocation,
};

const Region = ShModel.extend({
  name: attr('string'),
  description: attr('string'),

  formattedAddress: readOnly('name'),

  countries: hasMany('country', { async: false }),
});

export default Region;
